

document.addEventListener('DOMContentLoaded', function () {

  const timers = document.querySelectorAll('[data-deal-timer]');
  if (!timers.length) return;

  function pad(number) {
    return number.toString().padStart(2, '0');
  }

  function getNextDailyReset(resetHour) {
    const now = new Date();
    const reset = new Date();
    reset.setHours(resetHour, 0, 0, 0);
    if (now >= reset) reset.setDate(reset.getDate() + 1);
    return reset;
  }

  function getCampaignEnd(campaignEnd) {
    if (!campaignEnd) return null;
    const date = new Date(campaignEnd);
    return isNaN(date.getTime()) ? null : date;
  }

  timers.forEach(function (timerContainer) {

    const mode = timerContainer.dataset.timerMode;
    const resetHour = parseInt(timerContainer.dataset.resetHour, 10);
    const campaignEnd = timerContainer.dataset.campaignEnd;

    const hoursElement = timerContainer.querySelector('[data-timer-hours]');
    const minutesElement = timerContainer.querySelector('[data-timer-minutes]');
    const secondsElement = timerContainer.querySelector('[data-timer-seconds]');

    if (!hoursElement || !minutesElement || !secondsElement) return;

    function updateTimer() {
      let endTime;

      if (mode === 'daily') {
        endTime = getNextDailyReset(resetHour);
      } else if (mode === 'campaign') {
        endTime = getCampaignEnd(campaignEnd);
      } else {
        return;
      }

      if (!endTime) {
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';
        return;
      }

      const now = new Date();
      const difference = endTime.getTime() - now.getTime();

      if (difference <= 0) {
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';
        if (mode === 'daily') setTimeout(updateTimer, 1000);
        return;
      }

      const totalSeconds = Math.floor(difference / 1000);
      hoursElement.textContent = pad(Math.floor(totalSeconds / 3600));
      minutesElement.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      secondsElement.textContent = pad(totalSeconds % 60);
    }

    updateTimer();
    const countdown = setInterval(updateTimer, 1000);

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(timerContainer)) {
        clearInterval(countdown);
      }
    });
  });
});